import { array, string } from 'zod';

import { TENANT_CODE } from '../ApplicationProvider/ApplicationProvider.helpers';

/**
 * getProtectedClients
 *
 * Get an array of clients who's env should always be PW protected
 *
 * @returns
 */
const getProtectedClients = () => {
    const validator = array(string());
    const envArray = JSON.parse(import.meta.env.VITE_FIREWALL_TENANTS ?? '[]');

    const result = validator.safeParse(envArray);

    return result.success ? result.data : [];
};

/**
 * auth0Enabled
 *
 * Returns boolean for if auth should be enabled given the env variables
 *
 * @returns
 */
export const auth0Enabled = () => {
    const protectedClients = getProtectedClients();

    if (protectedClients.includes(TENANT_CODE)) return true;

    if (import.meta.env.VITE_API_ENV === 'prod' || import.meta.env.DEV)
        return false;

    return true;
};

export const isAuth0Enabled = auth0Enabled();
